import style from "./Presentation.module.css"
import water from "../../assets/Presentation/agua.jpg"
import sun from "../../assets/Presentation/sol.png"
import nature from "../../assets/Presentation/Naturaleza.png"
import logo from "../../assets/Logo_Granja_de_Pili_2026.jpg"

const Presentation = () => {

    
return (
    <div className={style.present}>
        <div className={style.title}>
            <p>Somos un proyecto familiar por el cuidado del medio ambiente a 30 minutos de Cali</p>
            <img src={logo} alt="logo"/>
            
        </div >
        <div className={style.rema}>
            <p>"En la Granja de Pili sembramos con fe, cosechamos con trabajo y compartimos con amor"</p>
        </div>
        <div className={style.paragrah}>
            <div className={style.component}>
            <img src={water} alt=""/>
            <div className={style.group}>
                <h2>Agua</h2>
                <p>Acuaponía, utilización de aguas lluvias y riego controlado</p>
            </div>
            </div>

            <div className={style.component}>
                <img src={sun} alt=""/>
            <div className={style.group}>
                <h2>Energía</h2>
                <p>Calentador de agua solar, sistema fotovoltaíco y eficiencia enegética</p>
            </div>
            </div>

            <div className={style.component}>
                <img src={nature} alt=""/>
            <div className={style.group}>
                <h2>Naturaleza</h2>
                <p>Diversidad de aves, especies nativas y producción sostenible </p>
            </div>
            </div>
        </div>

    </div>

)

}

export default Presentation